<template>
  <div class="choosecontact" v-click-outside="chooseContactOutside">
    <div class="choosecontract-item">
      <div class="choosecontract-item-cell" style="width: 100%">
        <base-button
          style="width: 140px; height: 35px"
          type="primary"
          @click="ConfirmEvent"
          >Confirm
        </base-button>
        <base-button style="width: 140px; height: 35px" @click="CancelEvent"
          >Cancel
        </base-button>
      </div>
    </div>
    <div class="choosecontract-item">
      <div
        class="choosecontract-item-cell"
        style="
          width: 5%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
        "
      >
        <el-icon>
          <search />
        </el-icon>
      </div>
      <div class="choosecontract-item-cell" style="width: 95%">
        <el-input
          v-model="Keyword"
          clearable
          @input="ChangeKey"
          placeholder="Keyword Search"
        ></el-input>
      </div>
    </div>
    <div class="choosecontract-item" style="height: 180px">
      <div class="choosecontract-item-cell" style="overflow-y: auto">
        <el-table
          :data="useOrder.ContactOptionals"
          style="width: 100%"
          border
          v-if="useOrder.ContactOptionals?.length > 0"
          @row-click="handleClickTableRow"
        >
          <el-table-column label=" " min-width="10%">
            <template #default="scope">
              <div style="text-align: center">
                <el-checkbox
                  style="zoom: 150%"
                  v-model="scope.row.isChecked"
                ></el-checkbox>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="contactPerson"
            label="Contact Person"
            min-width="30%"
          >
            <template #default="scope">
              <div style="display: flex; flex-wrap: wrap">
                <div style="width: 100%">
                  {{ scope.row.contactPerson }}
                  <span
                    v-if="
                      scope.row.jobTitle != null && scope.row.jobTitle != ''
                    "
                  >
                    ({{ scope.row.jobTitle }})</span
                  >
                </div>
                <div style="width: 100%">
                  Tel.:&nbsp;&nbsp;{{ scope.row.contactTel }}
                </div>
                <div style="width: 100%">
                  Fax:&nbsp;&nbsp;{{ scope.row.contactFax }}
                </div>
                <!-- <div style="width: 100%">
                  Mobile:&nbsp;&nbsp;{{ scope.row.contactMobile }}
                </div> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="contactEmail" label="Email" min-width="40%">
          </el-table-column>
          <el-table-column prop="contactOwner" label="Owner" min-width="20%">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import baseCheckbox from '@/components/newUI/Inputs/BaseCheckbox';
// vue
import { ref, onBeforeMount } from 'vue';
// element icon
import { Select, Close, Search } from '@element-plus/icons-vue';
// api
import { useOrderStore } from '@/store/order';
import { storeToRefs } from 'pinia';
import { ClickOutside as vClickOutside } from '@/assets/js/directive';

// useOrder
const useOrder = useOrderStore();
const Keyword = ref('');

const props = defineProps({
  isEnable: {
    type: Boolean,
    default: false,
    description: '是否启用',
  },
});

// const CustomerId = ref(0);
onBeforeMount(async () => {});

const emits = defineEmits(['close', 'confirm']);
const CancelEvent = () => {
  Keyword.value = '';
  emits('close');
};
const ConfirmEvent = () => {
  useOrder.addContactPerson();
  Keyword.value = '';
  emits('confirm');
};
//点击行选择
const handleClickTableRow = (row, data1, data2) => {
  if (data1.no != 0) {
    row.isChecked = !row.isChecked;
  }
};

//搜索
const ChangeKey = () => {
  useOrder.ContactOptionals = useOrder.ContactOptionalsOld.filter((p) => {
    return (
      p.contactPerson.toUpperCase().indexOf(Keyword.value.toUpperCase()) > -1
    );
  });
};

const chooseContactOutside = (e) => {
  if (props.isEnable) {
    if (e?.target?.attributes?.class?.value?.includes('btn-contact-person')) {
      return;
    }
    emits('close');
  }
};
</script>

<style scoped>
.choosecontract-item {
  display: flex;
  width: 100%;
}

.choosecontract-item-cell:not(first-child) {
  border-right-width: 0px;
}

.choosecontract-item-cell:last-child {
  border-right-width: 1px;
}

.choosecontract-item:not(first-child) .choosecontract-item-cell {
  border-top-width: 0px;
}

.choosecontract-item:first-child .choosecontract-item-cell {
  border-top-width: 1px;
}

.choosecontract-item-cell {
  padding: 10px;
  border: 1px solid #cecece;
  width: 100%;
}
</style>
